<div class="property">
  <ax-icon
    *ngIf="showIcon"
    class="icon type-icon"
    [name]="customIcon ? customIcon : 'message-star'"
  ></ax-icon>
  <ax-rating-edit
    [form]="form"
    [label]="label"
    [required]="required"
    [readonly]="readonly"
  ></ax-rating-edit>
  <div class="hint-wrapper">
    <mat-hint class="hint" align="end" *ngIf="form.valid || form.untouched">
      {{ hint }}
    </mat-hint>
    <ax-property-error *ngIf="form.touched" [form]="form" [label]="label"></ax-property-error>
  </div>
</div>
